<template>
  <div id="CheckEligibilityStage">
    <ffs-welcome></ffs-welcome>
    <el-steps finish-status="success" simple>
      <el-step title="Profile" v-bind:status="this.Profile.StepState"></el-step>
      <el-step title="Charges" v-bind:status="this.Charges.StepState"></el-step>
      <el-step title="Results" v-bind:status="this.Result.StepState"></el-step>
    </el-steps>
    <template v-if="(this.Profile.complete === true) && (this.Charges.complete === false)">
      <div style="margin-bottom: 20px;">Click "Yes" if you've pled guilty or no-contest to any of the following:</div>
    </template>
    <router-view class="EligibilityStage" v-bind="userData"></router-view>
  </div>
</template>

<script>
import EventBus from '../../EligibilityEventBus.js'

import { Steps, Step } from 'element-ui' // eslint-disable-line no-unused-vars

const WelcomeDialogView = () => import(/* webpackChunkName: "WelcomeDialog" */ '@/components/views/WelcomeDialog.vue')

export default {
  data: function () {
    return {
      Profile: {
        complete: false,
        StepState: 'analysis'
      },
      Charges: {
        complete: false,
        StepState: ''
      },
      Result: {
        isExpungementEligible: false,
        isJuvenile: false,
        isJuvenileEarlyEligible: false,
        completedJuvenileDiversion: false,
        RequestsExpungementHelp: false,
        RequestsConsumerHelp: false,
        ExpungementNotes: '',
        ConsumerNotes: '',
        StepState: '',
        hasConsumerIssue: false
      }
    }
  },

  components: {
    'el-steps': Steps,
    'el-step': Step,
    'ffs-welcome': WelcomeDialogView
  },

  methods: {
    setProfileComplete (payload) {
      this.Profile = Object.assign(this.Profile, payload)

      this.Profile.StepState = 'success'
      this.Profile.complete = true
      this.Charges.StepState = 'analysis'
      this.$root.$router.push({ name: 'EligibilityCharges' })
    },

    setChargesComplete (payload) {
      this.Charges = Object.assign(this.Charges, payload)

      this.Charges.StepState = 'success'
      this.Charges.complete = true
      this.Result.StepState = 'success'
      this.$root.$router.push({ name: 'EligibilityResults' })
    },

    getChargesState () {
      return this.Charges.complete
    },

    handleCompletedEligibility (payload) {
      this.Result.isExpungementEligible = payload.isEligible
      this.Result.isJuvenile = payload.isJuvenile
      this.Result.isJuvenileEarlyEligible = payload.isEarlyEligible
      this.Result.completedJuvenileDiversion = payload.completedDiversion
      this.Result.ExpungementNotes = payload.notes
    },

    handleCompletedConsumerEligibility (payload) {
      this.Result.hasConsumerIssue = payload.result
      this.Result.ConsumerNotes = payload.notes
    },

    handleRequestingHelp (payload) {
      this.Result.RequestsExpungementHelp = payload.isRequestingExpungementHelp
      this.Result.RequestsConsumerHelp = payload.isRequestingConsumerHelp

      this.$root.$router.push({ name: 'EligibilityHelp' })
    },

    handleRequestingSelfHelp () {
      this.$root.$router.push({ name: 'SelfHelp' })
    }
  },

  computed: {
    userData: function () {
      if (this.$route.name === 'EligibilityResults') {
        return { profileData: this.Profile, chargeData: this.Charges }
      } else {
        return { profileData: null, chargeData: null }
      }
    }
  },

  created: function () {
    EventBus.$on('ProfileComplete', this.setProfileComplete)
    EventBus.$on('ChargesComplete', this.setChargesComplete)
    EventBus.$on('completedEligibility', this.handleCompletedEligibility)
    EventBus.$on('completedConsumerEligibility', this.handleCompletedConsumerEligibility)
    EventBus.$on('requestHelp', this.handleRequestingHelp)
    EventBus.$on('visitSelfHelp', this.handleRequestingSelfHelp)
  },

  mounted: function () {
    this.$root.$router.push({ name: 'EligibilityProfile' })
  }
}
</script>

<style scoped>
  #CheckEligibilityStage {
    margin: 10px;
    font-size: 1.0em;
    clear: both;
  }

  #CheckEligibilityStage >>> .el-steps {
    background: none;
    padding: 10px;
    padding-bottom: 20px;
    font-size: 9px !important;
  }

  #CheckEligibilityStage >>> .el-step__title {
    font-size: 9px !important;
  }

  #CheckEligibilityStage >>> .el-step.is-simple .el-step__title {
    font-size: 9px !important;
  }

  #CheckEligibilityStage >>> #ResultsStage .el-card {
    text-align: center;
    margin: auto;
    margin-bottom: 20px;
  }

  #CheckEligibilityStage >>> #ResultsStage .el-card p {
    text-align: left;
  }
</style>
